// NOTE: We need to ignore the import here because the file is generated by
//         the build process and is not available when linting in CI.
// eslint-disable-next-line import/no-unresolved
import styleFunction from '../../tmp/mapsight-vector-styles/vector-style.js';

window.__nnms3_style_function = styleFunction;
